module.exports = __webpack_public_path__ + "img/pass.afa05bc7.svg";